import React from "react";
import { Link } from "react-router-dom";
import PriorityIcon from "../../Misc/PriorityIcon";
export default function MaintListItem(props) {
  const clickHandler = (e) => {
    if (props.onPick) {
      e.preventDefault();
    }
  };

  const dblClickHandler = (e) => {
    if (props.onPick) {
      e.preventDefault();
      props.onPick(props);
    }
  };

  return (
    <>
      <Link
        onClick={(e) => clickHandler(e)}
        onDoubleClick={(e) => dblClickHandler(e)}
        to={`/maint/${props.structure}/${props.id}`}
      >
        <div
          className={`row py-4 px-2 border-bottom text-dark bg-hover-light ${
            props.highlightItem === String(props.id) ? "bg-light" : ""
          }`}
        >
          <div className="col-lg-12 m-lg-0 my-3">
            <div>
              {props.statecode === "expired" && (
                <i
                  className="fa fa-clock-o mr-2 text-danger"
                  title="ТО просрочено"
                ></i>
              )}
              <PriorityIcon {...props} className="mr-1 " />
              {props.label}
            </div>

            {props.description && (
              <div className="text-dark-50 small">{props.description}</div>
            )}
          </div>
        </div>
      </Link>
    </>
  );
}
